import { TLegacyTransactionStatus, TTransactionKind, TTransactionSource } from './types';

// compat values of GET api/transactions (payment gateway API, section 1.5)
export const TRANSACTIONS_STATE_COMPLETED = 'COMPLETED';
export const TRANSACTIONS_STATE_PENDING = 'PENDING';
export const TRANSACTIONS_STATE_FAILED = 'FAILED';
export const TRANSACTIONS_STATE_CANCELLED = 'CANCELLED';
export const TRANSACTIONS_STATE_REFUNDED = 'REFUNDED';

export const PAYMENT_METHOD_TYPE_CARD = 'CARD';
export const PAYMENT_METHOD_TYPE_APPLE_PAY = 'APPLE_PAY';
export const PAYMENT_METHOD_TYPE_GOOGLE_PAY = 'GOOGLE_PAY';
export const PAYMENT_METHOD_TYPE_DIRECT_DEBIT = 'DIRECT_DEBIT';

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
	[PAYMENT_METHOD_TYPE_CARD]: 'Card',
	[PAYMENT_METHOD_TYPE_APPLE_PAY]: 'Apple Pay',
	[PAYMENT_METHOD_TYPE_GOOGLE_PAY]: 'Google Pay',
	[PAYMENT_METHOD_TYPE_DIRECT_DEBIT]: 'Direct Debit',
};

export const STATE_LABELS: Record<string, string> = {
	[TRANSACTIONS_STATE_COMPLETED]: 'Payment completed',
	[TRANSACTIONS_STATE_PENDING]: 'Payment pending',
	[TRANSACTIONS_STATE_FAILED]: 'Payment failed',
	[TRANSACTIONS_STATE_CANCELLED]: 'Payment cancelled',
	[TRANSACTIONS_STATE_REFUNDED]: 'Refunded',
};

export const STATE_COLORS: Record<string, string> = {
	[TRANSACTIONS_STATE_COMPLETED]: 'green',
	[TRANSACTIONS_STATE_PENDING]: '#ffa700',
	[TRANSACTIONS_STATE_FAILED]: 'red',
	[TRANSACTIONS_STATE_CANCELLED]: '#ffa700',
	[TRANSACTIONS_STATE_REFUNDED]: '#7b1fa2',
};

// cardBrand of GET api/transactions: VISA, MASTERCARD, AMEX, ...; null for Direct Debit
export const CARD_BRAND_LABELS: Record<string, string> = {
	VISA: 'Visa',
	MASTERCARD: 'Mastercard',
	AMEX: 'American Express',
	DISCOVER: 'Discover',
	JCB: 'JCB',
	UNIONPAY: 'UnionPay',
	UNION_PAY: 'UnionPay',
	DINERS: 'Diners Club',
	DINERS_CLUB: 'Diners Club',
	MAESTRO: 'Maestro',
};

// source / kind of GET api/transactions: rows of the previous payment system, refunds as separate rows
export const TRANSACTION_SOURCE_LEGACY: TTransactionSource = 'legacy';
export const TRANSACTION_KIND_REFUND: TTransactionKind = 'refund';

export const LEGACY_SOURCE_LABEL = 'Previous payment system';
export const LEGACY_RECEIPT_HINT =
	'Receipts are not available for payments made via the previous payment system.';

// status of the previous payment system -> compat state of the status visuals (STATE_LABELS, STATE_COLORS)
export const LEGACY_STATUS_STATES: Record<string, string> = {
	succeeded: TRANSACTIONS_STATE_COMPLETED,
	failed: TRANSACTIONS_STATE_FAILED,
	cancelled: TRANSACTIONS_STATE_CANCELLED,
	processing: TRANSACTIONS_STATE_PENDING,
} satisfies Record<TLegacyTransactionStatus, string>;

// refund rows (kind "refund"): "Refund" when succeeded, otherwise by status
export const REFUND_LABEL = 'Refund';
export const REFUND_STATUS_LABELS: Record<string, string> = {
	processing: 'Refund pending',
	failed: 'Refund failed',
	cancelled: 'Refund cancelled',
};

export const TRANSACTION_TYPE_LABELS: Record<string, string> = {
	link: 'Payment link',
	manual: 'Manual payment',
	auto: 'Automatic payment',
	eu_ddp: 'EU DDP prepayment',
};
